import { formatUserFacingError } from '@/lib/errors'
import { useCallback, useEffect, useState } from 'react'
import { adminFilmsService } from '../services/admin.films.service'
import type { FilmDocument } from '@/types'

interface UseAdminProjectsResult {
  projects: Array<FilmDocument & { id: string }>
  loading: boolean
  error: string | null
  deleteProject: (id: string) => Promise<void>
  refresh: () => void
}

export function useAdminProjects(): UseAdminProjectsResult {
  const [projects, setProjects] = useState<Array<FilmDocument & { id: string }>>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [tick, setTick] = useState(0)

  const refresh = useCallback(() => {
    setTick((t) => t + 1)
  }, [])

  useEffect(() => {
    setLoading(true)
    setError(null)
    adminFilmsService
      .getAllProjects()
      .then(setProjects)
      .catch((err: unknown) =>
        setError(formatUserFacingError(err, 'Failed to load projects'))
      )
      .finally(() => setLoading(false))
  }, [tick])

  const deleteProject = useCallback(async (id: string): Promise<void> => {
    await adminFilmsService.deleteFilm(id)
    refresh()
  }, [refresh])

  return { projects, loading, error, deleteProject, refresh }
}
